import React from 'react';
import './cta.css';

const CTA = () => {
  return (
    <div className='gpt3__cta'>
      <div className='gpt3__cta-content'>
        <p>Pronto para transformar seu negócio?</p>
        <h3>Entre em contacto e descubra como podemos ajudar sua empresa a crescer.</h3>
      </div>
      <div className='gpt3__cta-btn'>
        <button type='button'>Fale Connosco</button>
      </div>
    </div>
  )
}

export default CTA
